import { useEffect, useRef, useState } from 'react'

type RotatingNumberProps = {
  number: string
  length: number
  interval?: number
  duration?: number
}

export default function RotatingNumber({
  number, length, interval = 50, duration = 1500
}: RotatingNumberProps) {
  const el = useRef<HTMLSpanElement>(null)
  const random = Math.floor(Math.random() * 1000).toString().padStart(length, '0')
  const [counter, setCounter] = useState(random)

  useEffect(() => {
    const myInterval = setInterval(() => {
      const random = Math.floor(Math.random() * 1000).toString().padStart(length, '0')
      setCounter(random)
    }, interval)

    // Stop after 3 seconds
    setTimeout(() => {
      clearInterval(myInterval)
      setCounter(number)
    }, duration)

    return () => clearInterval(myInterval)
  }, [])

  return (
    <span ref={el}>{counter}</span>
  )
}